import React from 'react';
import { Create, SimpleForm, NumberInput } from 'react-admin';

const ContractsCreate = () => (
  <Create>
    <SimpleForm>
      <NumberInput source="assignment_id" />
    </SimpleForm>
  </Create>
);

export default ContractsCreate;
